import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=7420744c&scoped=true"
import script from "./Section.vue?vue&type=script&setup=true&lang=js"
export * from "./Section.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Section.vue?vue&type=style&index=0&id=7420744c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7420744c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7420744c')) {
      api.createRecord('7420744c', component.options)
    } else {
      api.reload('7420744c', component.options)
    }
    module.hot.accept("./Section.vue?vue&type=template&id=7420744c&scoped=true", function () {
      api.rerender('7420744c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/operation/components/activity-types/firstDepositReward/Section.vue"
export default component.exports